import { z } from "zod";

/**
 * The rights & roles page's tab ids. Shared by the route's `?tab=` validation
 * and the page body's tab writes — see `admin/integrations/integrations-tabs.ts`
 * for why this is a third module rather than an export from either side.
 */
export const rightsTab = z.enum(["capabilities", "tools"]);

export type RightsTab = z.infer<typeof rightsTab>;
